// extracted by mini-css-extract-plugin
export default {"section":"Os-z","sectionTitle":"Ps-z","fieldWrapper":"Qs-z","formField":"Rs-z","disabled":"Ss-z","formLabel":"Ts-z"};